// © Microsoft Corporation. All rights reserved.

import { canUseDOM } from "@msnews/isomorphic-util";

/**
 * Helper to do a rAF + zero setTimeout to report render perf markers.
 * @param callback - The callback that will be invoked after the
 *  rAF + setTimeout combo.
 */
export function rafTimer(callback: Function): void {
    canUseDOM() && requestAnimationFrame(() =>
        setTimeout(() => callback(), 0)
    );
}